import React from 'react';

const PremiumCardOwnerFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.50002 5.83325H3.03032C2.27721 5.83325 1.66669 6.43953 1.66669 7.18742V15.3124C1.66669 16.0603 2.27721 16.6666 3.03032 16.6666H15.3031C16.0562 16.6666 16.6667 16.0603 16.6667 15.3124V13.7499"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.66669 10H9.16669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14.6528 3.33325L15.833 5.72422L18.4722 6.10999L16.5625 7.97006L17.0132 10.5978L14.6528 9.35652L12.2923 10.5978L12.743 7.97006L10.8333 6.10999L13.4725 5.72422L14.6528 3.33325Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PremiumCardOwnerFilterIcon;
